module.exports = __webpack_public_path__ + "static/media/terms_and_conditions.be4502f2.pdf";